import script from "./ViewArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewArticle.vue?vue&type=script&setup=true&lang=js"

import "./ViewArticle.vue?vue&type=style&index=0&id=955b50be&scoped=true&lang=css"
import "./ViewArticle.vue?vue&type=style&index=1&id=955b50be&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-955b50be"]])

export default __exports__